/**
 * @file TableMotoristasFilters.styles.ts
 * @description Contains style definitions for the date picker component used in the timesheet filters table.
 * The styles are tailored for consistent typography, color, and sizing, and provide customizations for
 * Material UI form labels and input adornments to match the application's design system.
 */
export const datePickerSx = {
	fontFamily: 'var(--font-family)',
	fontWeight: 500,
	lineHeight: 1.5,
	'& .MuiIconButton-root': {
		color: 'var(--primary)',
	},
	'& .MuiInputAdornment-root > button': {
		color: 'var(--primary)',
		width: '0.75em',
		height: '0.75em',
		marginRight: '-2px',
	},
}
export const datePickerCalendarSx = {
	'& .MuiPickersArrowSwitcher-button': {
		color: 'var(--primary)',
	},
	'& .MuiPickersCalendarHeader-switchViewButton': {
		color: 'var(--primary)',
	},
	'& .MuiPickersCalendarHeader-label': {
		textTransform: 'capitalize',
	},
	'& .MuiDayCalendar-weekDayLabel': {
		color: 'var(--primary-light) !important',
		textTransform: 'uppercase',
	},
	'& .MuiDayCalendar-weekContainer > .MuiPickersDay-root:nth-of-type(7n)': {
		color: 'var(--primary-light) !important',
	},
	'& .MuiPickersDay-today': {
		borderColor: 'var(--primary) !important',
	},
	'& .MuiPickersDay-root.Mui-selected': {
		backgroundColor: 'var(--primary) !important',
	},
}
export const datePickerInputPropsStyle = {
	fontFamily: 'var(--font-family)',
	fontSize: '0.75rem',
	color: 'var(--primary-dark)',
	fontWeight: 500,
	lineHeight: 1.5,
	paddingBlock: '8px',
}
export const menuItemDriverSx = {
	display: 'flex',
	flexDirection: 'row',
}
export const menuItemDriverNameSx = {
	width: '85%',
	fontFamily: 'var(--font-family)',
	color: 'var(--primary-dark)',
	fontSize: '0.75rem',
	fontWeight: 500,
	lineHeight: 1.5,
}
export const menuItemInternalNumberSx = {
	width: '15%',
	marginInlineStart: '1rem',
	color: 'var(--primary-light)',
	fontFamily: 'var(--font-family)',
	fontSize: '0.75rem',
	fontWeight: 500,
	lineHeight: 1.5,
}
export const formControlSx = {
	minWidth: '160px',
	fontFamily: 'var(--font-family)',
	'& .MuiInputLabel-root': {
		fontFamily: 'var(--font-family)',
		fontSize: '0.75rem',
		color: 'var(--primary-dark)',
		fontWeight: 500,
		lineHeight: 1.5,
		'& fieldset': {
			borderColor: 'rgba(134, 149, 175, 0.30)',
		},
		'& fieldset.Mui-focused': {
			borderColor: 'var(--primary) !important',
		},
	},
	'& .MuiInputLabel-shrink': {
		top: '4px',
		left: '-3px',
		fontSize: '11px',
		backgroundColor: '#fff',
		width: 'fit-content',
		paddingInline: '6px 24px',
		'&.Mui-focused': {
			color: 'var(--primary)',
		},
	},
}
export const selectSx = {
	width: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	textAlign: 'left',
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 500,
	lineHeight: 1.5,
	'& .MuiInputLabel-root': {
		fontFamily: 'Poppins',
		fontSize: '13px',
		color: 'var(--primary-dark)',
		fontWeight: 500,
		lineHeight: 1.5,
	},
	'& .MuiSelect-icon': {
		color: 'var(--primary)',
		marginRight: '2px',
	},
	'& fieldset': {
		borderColor: 'rgba(134, 149, 175, 0.30)',
	},
	'&.Mui-focused fieldset': {
		borderColor: 'var(--primary) !important',
	},
}
export const menuItemStatusSx = {
	fontFamily: 'Poppins',
	fontSize: '12px',
	fontWeight: 500,
	lineHeight: 1.5,
	color: 'var(--primary-dark)',
	display: 'flex',
	alignItems: 'center',
	gap: '9px',
}
export const checkboxSx = {
	width: '15px',
	height: '15px',
	color: 'var(--primary-light)',
	'&.Mui-checked': {
		color: 'var(--primary)',
	},
}
export const listItemTextPrimaryTypographyProps = {
	fontFamily: 'Poppins',
	fontSize: '12px',
	fontWeight: 500,
	lineHeight: 1.5,
	color: 'var(--primary-dark)',
}
export const tabPageTotalsBoxSx = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	marginBottom: -1,
}
export const tabPageTotalsTextStyle = {
	fontFamily: 'var(--font-family)',
	fontSize: '14px',
	fontWeight: 600,
	lineHeight: 1.5,
	color: 'var(--primary-dark)',
}
export const tabPageChipSx = {
	'--height': '24px',
	display: 'flex',
	minHeight: 'var(--height)',
	maxHeight: 'var(--height)',
	padding: '3px 4px',
	alignItems: 'center',
	borderRadius: 'var(--height)',
	border: '1px solid var(--primary)',
	background: 'rgba(0, 165, 255, 0.05)',
	cursor: 'pointer',
	'& .MuiChip-deleteIcon': {
		width: '16px',
		height: '16px',
		color: 'var(--primary)',
	},
}
export const chipLabelBoxSx = {
	display: 'flex',
	alignItems: 'center',
	gap: 0.5,
	fontSize: '0.75rem',
	fontWeight: 500,
}
export const chipLabelIconSx = { width: '18px', height: '18px', color: 'var(--primary)', marginLeft: 'auto' }
